import common from '../common.js';

export default {
  async loadTickets(context, payload ) 
  {
    const responseJson = await common.getRequest(context, payload, 'ticket')
    context.commit('setTickets', responseJson)    
  },
  async loadTicketTypes(context, payload ) 
  {
    const responseJson = await common.getRequest(context, payload, 'ticket/ticket-types')
    context.commit('setTicketTypes', responseJson)    
  },
  async loadTicketStatuses(context, payload ) 
  {
    const responseJson = await common.getRequest(context, payload, 'ticket/status-types')
    context.commit('setTicketStatuses', responseJson)    
  },
  async loadTicketNotes(context, payload ) 
  {
    const responseJson = await common.getRequest(context, payload, `ticket/ticket-notes?id=${payload.ticketId}`)
    context.commit('setTicketNotes', responseJson)    
  },
  async saveTicketNote(context, payload)
  {
    console.log("SAVE NOTE ACTION", payload)
    const responseJson = await common.postRequest(context, payload, 'ticket/ticket-notes')
  },
  async updateTicketStatuses(context, payload)
  {
    await common.postRequest(context, payload, 'ticket/update-status')
  },

};
